module.exports = __webpack_public_path__ + "img/privacy_mod.38fc2316.png";